export enum InviteFlowFields {
  EMAIL = 'EMAIL',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  ADMIN_CORPORATE_RESOLUTION = 'ADMIN_CORPORATE_RESOLUTION',
  APPOINT_ADMIN = 'APPOINT_ADMIN',
  ACCOUNTANT_VIEWER_TERMS = 'ACCOUNTANT_VIEWER_TERMS',
}
